import * as React from 'react';
import { Badge, StatusBadge } from '@repo/ui-web';
import { badgeStates } from '../../catalog/component-states';
import { StateToggle } from '../../components/StateToggle';

const statusTones = ['success', 'warning', 'error', 'info', 'neutral'] as const;

export function BadgeShowcase() {
  const [variant, setVariant] = React.useState<(typeof badgeStates)[number]>('success');
  const [bordered, setBordered] = React.useState(false);

  return (
    <div className="space-y-8">
      <div className="space-y-4">
        <StateToggle options={badgeStates} value={variant} onChange={setVariant} label="Variant" />
        <Badge variant={variant}>New</Badge>
      </div>

      <div className="space-y-2">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">
          StatusBadge
        </p>
        <div className="flex items-center gap-2">
          <button
            type="button"
            className="type-body-sm text-muted-foreground underline"
            onClick={() => setBordered(!bordered)}
          >
            {bordered ? 'Bordered' : 'No border'}
          </button>
        </div>
        <div className="flex flex-wrap gap-2">
          {statusTones.map((tone) => (
            <StatusBadge key={tone} tone={tone} bordered={bordered}>
              {tone}
            </StatusBadge>
          ))}
        </div>
      </div>
    </div>
  );
}
